import { boxShadowValuesV2 } from '@shared/utils/style/dropShadows';
import { styled } from '@withjoy/joykit';

export const DrawerLayout = styled.div<{
  readonly $isOpen: boolean;
}>`
  position: absolute;
  height: 100vh;
  overflow-y: ${({ $isOpen }) => ($isOpen ? 'auto' : 'hidden')};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
`;

export const DrawerContent = styled.div`
  box-shadow: ${boxShadowValuesV2?.hardxs};
  pointer-events: auto;
  background-color: white;
  border-top-left-radius: ${({ theme }) => theme.radii[4]};
  border-top-right-radius: ${({ theme }) => theme.radii[4]};
`;

export const ScrollTopContainer = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.space[1]};
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 11;
  pointer-events: auto;
`;
